import { Plane, Vector3 } from "three";
import ExtrudedLoopAnnotationSceneObject from "./ExtrudedLoopAnnotationSceneObject";
import AreaAnnotationData from "../sceneObjectData/AreaAnnotationData";
import EditHandleData from "../sceneObjectData/EditHandleData";
import EditHandleTypeEnum from "../../enums/EditHandleTypeEnum";
import CommandIdEnum from "../../enums/CommandIdEnums";
import { isPlaneEdgeOn } from "../../utils/editHandleVisibility";

export default class AreaAnnotationSceneObject extends ExtrudedLoopAnnotationSceneObject<AreaAnnotationData> {

    getEditHandles(localViewDirection: Vector3): EditHandleData[] {
        const data = this.data;

        // Seen edge-on the polygon is just a line, so dragging its vertices in-plane is pointless.
        if (isPlaneEdgeOn(localViewDirection, data.placement.axis))
            return super.getEditHandles(localViewDirection);

        // placement.axis is the profile plane's normal (Z); refDirection is the in-plane X axis.
        const plane = new Plane().setFromNormalAndCoplanarPoint(
            data.placement.axis.clone(),
            data.placement.location.clone()
        );

        return [
            ...super.getEditHandles(localViewDirection),
            ...data.points.map((point, i) =>
                new EditHandleData(data.uuid, EditHandleTypeEnum.POLYGON_VERTEX, data.placement.location.clone().add(point),
                    CommandIdEnum.GeometryPolygonEndpointMove,
                    (d, delta) => {
                        (d as AreaAnnotationData).points[i].add(delta);
                    },
                    plane.clone())
            )
        ];
    }
}
